import React from 'react';
import { usePromoModel } from '../../../../contexts/PromoModelProvider';
import { usePromoCart } from '../../../../contexts/PromoCartProvider';
import { formatPrice } from '../../../../utils/promo-presentation-utils';
import './ProgressBar.scss';

export const ProgressBar = () => {
  const {
    minPurchaseQuantity, minPurchaseAmount, rewardAmountPerItem, rewardPercent, rewardAmountPerOrder
  } = usePromoModel();
  const { promoCartQuantity, promoCartValue } = usePromoCart();

  const progressMadeQuantity = Math.floor((promoCartQuantity / minPurchaseQuantity) * 100);
  const progressMadeAmount = Math.floor((promoCartValue / minPurchaseAmount) * 100);
  const progressMade = Math.min(100, minPurchaseQuantity ? progressMadeQuantity : progressMadeAmount);

  const amountLeftToQualify = Math.max(0, minPurchaseAmount - promoCartValue);
  const quantityLeftToQualify = Math.max(0, minPurchaseQuantity - promoCartQuantity);
  const toQualify = minPurchaseQuantity ? quantityLeftToQualify : formatPrice(amountLeftToQualify);

  const rewardText = () => {
    if (rewardAmountPerOrder) return `save ${formatPrice(rewardAmountPerOrder)} `;
    if (rewardPercent) return `${rewardPercent}% off `;
    return `save ${formatPrice(rewardAmountPerItem * promoCartQuantity)} `;
  };

  return (
    <div className="promo-progress-bar" data-testid="progress-bar">
      <div className="promo-progress-bar-message">
        {progressMade !== 100 ? (
          <span className="u__bold">
            <span>Add </span>
            <span className="u__text--success">{toQualify} More </span>
            <span>to Qualify</span>
          </span>
        ) : (
          <span className="u__bold">
            <span className="promo-messaging-container--success">Success! </span>
            <span>You {rewardPercent ? 'get ' : ''}</span>
            <span className="u__text--success">{rewardText()}</span>
            <span className="promo-messaging-container__large-screen-text">
              {!rewardPercent ? 'on ' : ''}this purchase
            </span>
          </span>
        )}
      </div>
      <div className="promo-progress-bar-wrapper">
        <div className="promo-progress-bar-main">
          <span
            className={`promo-progress-bar-level ${progressMade === 100 ? 'promo-progress-bar--success' : ''}`}
            style={{ width: progressMade + '%' }}
            data-testid="promo-progress-bar-level"
          />
        </div>
        <div className={`promo-progress-bar-icon ${progressMade === 100 ? 'promo-progress-bar-icon--success' : ''}`} />
      </div>
    </div>
  );
};

ProgressBar.displayName = 'ProgressBar';
